export default function ContactSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">联系我们</h2>
            <p className="text-sm md:text-base text-foreground-500">
              欢迎通过以下方式与51吃瓜网入口团队取得联系
            </p>
          </div>

          <div className="bg-background-100 rounded-lg p-6 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8">
              <div className="text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 mx-auto mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">投稿爆料</h3>
                <p className="text-xs text-foreground-400">tips@51chigua.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mx-auto mb-3">
                  <i className="ri-customer-service-line text-xl"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-400">biz@51chigua.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 mx-auto mb-3">
                  <i className="ri-question-line text-xl"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">内容反馈</h3>
                <p className="text-xs text-foreground-400">feedback@51chigua.com</p>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-background-200/70">
              <p className="text-sm text-foreground-500 text-center leading-relaxed">
                如果您有任何关于51吃瓜网站入口、51吃瓜网址、51吃瓜网在线访问的问题，或是对51吃瓜最新地址有疑问，欢迎随时联系我们。
                我们也会认真听取关于51吃瓜网怎么进的使用反馈，持续优化51吃瓜官方入口体验。
              </p>
              <div className="flex items-center justify-center gap-4 mt-6">
                <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="w-10 h-10 flex items-center justify-center rounded-md bg-background-200 text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="w-10 h-10 flex items-center justify-center rounded-md bg-background-200 text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="w-10 h-10 flex items-center justify-center rounded-md bg-background-200 text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer">
                  <i className="ri-vidicon-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}